import { DeliveryZone } from "src/app/models/interfaces/address.interface";

export interface ApiResponse<T> {
  success: boolean;
  data: T;
  error: string | null;
}

export interface PointOfSaleClosing {
  _id: number;
  date_from: string | null;
  date_to: string | null;
  hour_from: string;
  hour_to: string;
  comment: string | null;
  close_from: string | null;
  close_to: string | null
}

export interface PointOfSaleDayTimetable {
  day: number;                        // 0=dimanche, 1=lundi, etc.
  timetables: PointOfSaleTimetable[]; // les créneaux par SM pour ce jour
}

export interface PointOfSaleTimetable {
  _id: number;
  id_sale_method: number;
  day: number;
  hour_begin: string | null;
  hour_end: string | null;
  position: number;
  timeslots: TimeSlot[];
}

export interface TimeSlot {
  start: string;
  end: string;
}

export interface PointOfSaleSummary {
  id: number;
  idUser: number;
  idWebshop: string;
  denomination: string;
  address?: string | null;
  postal?: string | null;
  city?: string | null;
  country?: string | null;
  phone?: string | null;
  banner?: string | null;
  updatedAt?: string | null;
  img?: string | null;
  timetables?: PointOfSaleDayTimetable[];
  closing?: PointOfSaleClosing[];
  // Ancienne variables a virer ?
  url_encode?: string;
  closings?: PointOfSaleClosing[];
}

export interface PointOfSaleDetails extends PointOfSaleSummary {
  description?: string | null;
  stripeAccount?: string | null;
  yavinAccount?: number | null;
  paypalAccount?: number | null;
  payzenAccount?: number | null;
  enableOrderIntent?: number | null;
  enablePaymentNoteIntent?: number | null;
  shippingCosts?: any | null;
  eligibleZones: DeliveryZone[] | [];
  touchTerminal: any | null;
  myposAccount: any | null;
  payment_methods: PaymentMethod[] | [];
}

export interface PaymentMethod {
  id: number;
  name: string;
  paiment_type: PaymentType;
  type: number;
  visible: boolean;
}

type PaymentType =
  | 'online'
  | 'card'
  | 'secure_counter'
  | 'stripe'
  | 'online_paypal'
  | 'payzen'
  | 'counter'
  | 'touchTerminal'
  | 'myPos'
  | 'yavin'
  | 'nepting';

export function normalizePos(pos: any): PointOfSaleDetails {
  return {
    ...pos,
    denomination: pos.denomination ?? pos.name ?? "",
    img: pos.img ?? pos.logo ?? null,
    stripeAccount: pos.stripeAccount ?? pos.stripe_account ?? null,
    yavinAccount: pos.yavinAccount ?? pos.yavin_account ?? null,
    paypalAccount: pos.paypalAccount ?? pos.paypal_account ?? null,
    payzenAccount: pos.payzenAccount ?? pos.payzen_account ?? null,
    idWebshop: pos.idWebshop ?? pos.id_webshop ?? pos.id_webshop ?? "",
    idUser: pos.idUser ?? pos.id_user ?? pos.idUser ?? 0,
    enableOrderIntent: pos.enableOrderIntent ?? pos.enable_order_intent ?? pos.enableOrderIntent ?? 0,
    enablePaymentNoteIntent: pos.enablePaymentNoteIntent ?? pos.enable_payment_note_intent ?? pos.enablePaymentNoteIntent ?? 0,
    shippingCosts: pos.shippingCosts ?? pos.shipping_costs ?? pos.shippingCosts ?? null,
    eligibleZones: pos.eligibleZones ?? pos.eligible_zones ?? pos.eligibleZones ?? [],
    touchTerminal: pos.touchTerminal ?? pos.touch_terminal ?? pos.touchTerminal ?? null,
    myposAccount: pos.myposAccount ?? pos.mypos_account ?? pos.myposAccount ?? null,
  };
}
